var $e28eb809617bcace$exports = {};
$e28eb809617bcace$exports = {
    "loading": `\u{417}\u{430}\u{433}\u{440}\u{443}\u{437}\u{43A}\u{430}...`,
    "placeholder": `\u{412}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C}\u{2026}`
};


export {$e28eb809617bcace$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
